App.namespace('components.upload_manager_unload_prevention', () => {
  function preventLeaving(e) {
    // Cancel the event
    e.preventDefault(); // If you prevent default behavior in Mozilla Firefox prompt will always be shown
    // Chrome requires returnValue to be set
    e.returnValue = 'Changes you made may not be saved.';
  }

  function add() {
    window.addEventListener('beforeunload', preventLeaving);
  }

  function remove() {
    window.removeEventListener('beforeunload', preventLeaving);
  }

  return {
    add,
    remove,
  };
});
